export default {
  iconBadgeFillColor: '{:IconBadgeFillColor}',
};
